<template>
  <main class="not-found">
    <section class="card not-card">
      <svg class="art" viewBox="0 0 200 120" role="img" aria-label="Erro 404" xmlns="http://www.w3.org/2000/svg">
        <text x="100" y="82" text-anchor="middle" font-size="84" font-weight="800" fill="#2563eb" opacity="0.12" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif">404</text>
        <circle cx="88" cy="56" r="28" fill="#fff" stroke="#2563eb" stroke-width="6"/>
        <line x1="108" y1="76" x2="132" y2="100" stroke="#1e40af" stroke-width="8" stroke-linecap="round"/>
        <path d="M78 66c4-6 16-6 20 0" fill="none" stroke="#dc2626" stroke-width="4" stroke-linecap="round"/>
        <circle cx="78" cy="48" r="3.5" fill="#1a1a2e"/>
        <circle cx="98" cy="48" r="3.5" fill="#1a1a2e"/>
      </svg>
      <h1>Página não encontrada</h1>
      <p>Confira o link do evento ou entre em contato com a coordenação.</p>
      <a href="https://naelshaday.com.br" class="btn-primary back">Voltar ao site</a>
    </section>
  </main>
</template>

<script>
export default { name: 'NotFoundPage' }
</script>

<style scoped>
.not-found {
  min-height: 100vh;
  display: flex; align-items: center; justify-content: center;
  padding: var(--spacing-base);
  background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);
}
.not-card {
  padding: var(--spacing-xl);
  max-width: 480px; width: 100%;
  text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: var(--spacing-base);
}
.art { width: 200px; height: auto; }
h1 { font-size: var(--text-xl); color: var(--color-text-primary); }
p { color: var(--color-text-muted); }
.back { margin-top: var(--spacing-md); text-decoration: none; }
</style>
